// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disclaimer[data-v-edb8af28],.v-card__subtitle[data-v-edb8af28]{text-align:center}.disclaimer[data-v-edb8af28]{font-style:italic;width:60%;margin:auto}.right[data-v-edb8af28]{text-align:right}", ""]);
// Exports
module.exports = exports;
